import { t } from "@lingui/macro";
import { BudgetListing } from "@src/components/modules/budgets/export";
import { FullScreenContainer } from "@src/components/ui-kit";
import { NavigationProposals } from "@src/components/widgets/AppSubNav";
import { MainLayout } from "@src/components/widgets/Layout";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => {
  return (
    <MainLayout
      noBottomMargin
      fullWidth
      title={t`Budgets`}
      navigation={<NavigationProposals />}
    >
      <FullScreenContainer noBottomMargin>
        <BudgetListing />
      </FullScreenContainer>
    </MainLayout>
  );
};

export const Route = createFileRoute("/budgets/export")({
  component: Page,
});
